import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import 'bootstrap/dist/css/bootstrap.min.css';
import Project_overview from '../pages/Project_overview';
import '../css/Week.css'; // Import your external CSS file


function Week() {
    const [activeKey, setActiveKey] = useState("first"); // Initialize the active tab

    return (
        <div className="main-div-week">
            <Project_overview />

            <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>

                <Row>
                    <Col sm={3}>
                        <Nav variant="pills" className="custom-nav-class flex-column">
                            <Nav.Item>
                                <Nav.Link eventKey="first" className={activeKey === "first" ? "custom-link-active" : "custom-link"}>Week-1</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="second" className={activeKey === "second" ? "custom-link-active" : "custom-link"}>Week-2</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="third" className={activeKey === "third" ? "custom-link-active" : "custom-link"}>Week-3</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="fourth" className={activeKey === "fourth" ? "custom-link-active" : "custom-link"}>Week-4</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="fifth" className={activeKey === "fifth" ? "custom-link-active" : "custom-link"}>Week-5</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="sixth" className={activeKey === "sixth" ? "custom-link-active" : "custom-link"}>Week-6</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="seventh" className={activeKey === "seventh" ? "custom-link-active" : "custom-link"}>Week-7</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Col>


                    {/* Tab section ended */}


                    {/* content section */}
                    <Col sm={9}>
                        <Tab.Content>
                            <Tab.Pane eventKey="first" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">
                                    <h6>Discussion fundamental concepts and challenges in robotics:</h6>
                                    <hr />

                                    <h5>Topic: "Introduction to Robotics: Past, Present, and Future"</h5>
                                    <hr />

                                    <p><strong>Definition of Robotics:</strong> Robotics is an interdisciplinary field that encompasses computer science, mechanical engineering, electrical engineering, and more. It involves the design, construction, operation, and use of robots to perform various tasks.</p>
                                    <hr />
                                    <p><strong>Historical Overview:</strong> The history of robotics dates back centuries, but the term "robotics" was first coined in the early 20th century. Key milestones include the development of Unimate, the first industrial robot, in the 1960s. Since then, robotics has seen remarkable growth, with innovations in robotics technology and applications.</p>
                                    <hr />
                                    <p><strong>Applications:</strong> Today, robotics is applied in various fields, including manufacturing, healthcare, space exploration, agriculture, and more. For example, robotic arms are used in assembly lines to perform repetitive tasks, robotic surgical systems assist in minimally invasive surgeries, and autonomous robots explore distant planets.</p>
                                    <hr />
                                    <p><strong>Challenges:</strong> Robotics faces numerous challenges. Technical challenges include improving sensor technology, enhancing machine learning algorithms, and enabling effective human-robot interaction. Ethical challenges involve issues like job displacement due to automation, privacy concerns, and ethical decision-making by autonomous robots.</p>

                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">
                                    <div className="week-notes">
                                        <h5>Topics Discussion</h5>
                                        <ul>
                                            <li>Industrial Robotics.</li>
                                            <li>Service Robotics.</li>
                                            <li>Social/Personal Robotics.</li>
                                        </ul>
                                        <p>We delve into Industrial Robotics, Service Robotics, and Social/Personal Robotics, unveiling the intricate dynamics between humans and machines that redefine our world.</p>
                                    </div>

                                    <hr />

                                    <div className="tasks">
                                        <h5>Initial Tasks Assigned:</h5>
                                        <ol>
                                            <li>Formation of project group.</li>
                                            <li>Creation of a project website.</li>
                                            <li>Selection of the project.</li>
                                        </ol>
                                        <p>Our journey commences with three vital tasks: 1. Group formation, 2. Building our project website, and 3. Selecting our project. On our website, we'll connect our audience to our GitHub, LinkedIn, and ResearchGate profiles, establishing a holistic online presence.</p>

                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="third" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">
                                    <h5>Assessing Prior Class Task Performance and Evaluation</h5>
                                    <hr />
                                    <h5>Learning Object:</h5>
                                    <p>We're continuing our exploration of how to effectively conduct a literature review, focusing on the strategies and resources for discovering and accessing relevant research papers in a specific field of study.</p>

                                    <hr />

                                    <h5>Questionnaire:</h5>
                                    <ol>
                                        <li>What motivated your choice of this project?</li>
                                        <li>How does your project connect with Cobot and I Model?</li>
                                        <li>How did you identify research gaps through your literature review?</li>
                                    </ol>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="fourth" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">
                                    <h5>Assessing Prior Class Task Performance and Evaluation</h5>
                                    <hr />
                                    <h5>Initial Tasks Assigned:</h5>
                                        <ol>
                                            <li>Sketch the ProtoType</li>
                                            <li>Project Related 5 paper Review</li>
                                            <li>paper work </li>
                                        </ol>

                                    <hr />
                                  
                                    <h5>Paper Work:</h5>
                                    <ol>
                                        <li>Title</li>
                                        <li>Abstract</li>
                                        <li>Keyword</li>
                                        <li>Introduction[5-10]</li>
                                        <li>Litarature Review</li>
                                    </ol>
                                    <hr />

                                    <h5>Questionnaire:</h5>
                                    <ol>
                                        <li>What does this mean in HRI research?</li>
                                        <li>How does this fit with your throughs on designing robot?</li>
                                        <li>How did you identify research gaps through your literature review?</li>
                                    </ol>







                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="fifth" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">
                                <h2>Assigned Tasks:</h2>
      <ol>
        <li>
          Systematic Block Diagram
        </li>
        <li>
         Components listing and purchasing
        </li>
        <li>
          For Paper:
          <ul>
            <li>
              Introduction with reference.
            </li>
            <li>
              Literature Review with 3-5 sub-sections + tables
            </li>
          </ul>
        </li>
        <li>
          System Design
        </li>
        <li>
          Specification of the components to be used in the project
        </li>
      </ol>
      <p>
        <b>NOTE: Week 4 + Week 5 progress will be checked in the next class.
            <p>
            For paper writing guidelines, please follow the reference papers provided by the faculty.</p></b>
      </p>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="sixth" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">Week-6 content</div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="seventh" className="custom-tab-pane">
                                <div className="p-3 custom-content-class">Week-7 content</div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>

        </div >
    );
}

export default Week;
